// extracted by mini-css-extract-plugin
module.exports = {"box":"dashboard_box__3nLsb","biglink":"dashboard_biglink__-EsKY","hotkeyHint":"dashboard_hotkeyHint__A1G7s"};